var map = {
	"./sample/sample.vue": "./datatrans-website/assets/src/js/app/framework/global-components/page/sample/sample.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./datatrans-website/assets/src/js/app/framework/global-components/page sync recursive [a-zA-Z0-9-]+\\.(?:component\\.js|vue$)";